import { render } from "./Button.vue?vue&type=template&id=24e1c6b6&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=24e1c6b6&lang=scss&scoped=true"

import exportComponent from "D:\\ProjectsWeb\\road-maintenance-launcher\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e1c6b6"]])

export default __exports__